<ng-container *ngrxLet="availableMarkers$ as availableMarkers">
    <ng-container *ngrxLet="availableColorMarkers$ as availableColorMarkers">
        <ng-container *ngrxLet="hasMarkers$ as hasMarkers">
            <div class="flex-row">
                <button
                    (click)="downloadMarkers()"
                    [disabled]="!hasMarkers"
                    class="icon-button"
                    [attr.aria-label]="'Download markers'"
                    [title]="
                        hasMarkers
                            ? 'Download all markers for dataset in JSON format'
                            : 'No data available for download'
                    "
                >
                    <cds-icon shape="download"></cds-icon>
                </button>
                <clr-combobox-container>
                    <label>X-Axis</label>
                    <clr-combobox
                        name="x-axis-marker-selection"
                        [ngModel]="markerXAxis$ | async"
                        (ngModelChange)="setDataXAxis($event)"
                        [disabled]="!hasMarkers"
                    >
                        <clr-options>
                            <clr-option
                                *clrOptionItems="let marker of availableMarkers; field: 'name'"
                                [clrValue]="marker"
                            >
                                {{ marker.name }}
                            </clr-option>
                        </clr-options>
                    </clr-combobox>
                </clr-combobox-container>
                <clr-combobox-container>
                    <label>Y-Axis</label>
                    <clr-combobox
                        name="y-axis-marker-selection"
                        [ngModel]="markerYAxis$ | async"
                        (ngModelChange)="setDataYAxis($event)"
                        [disabled]="!hasMarkers"
                    >
                        <clr-options>
                            <clr-option
                                *clrOptionItems="let marker of availableMarkers; field: 'name'"
                                [clrValue]="marker"
                            >
                                {{ marker.name }}
                            </clr-option>
                        </clr-options>
                    </clr-combobox>
                </clr-combobox-container>
                <clr-combobox-container>
                    <label>Color-Axis</label>
                    <clr-combobox
                        name="color-axis-marker-selection"
                        [ngModel]="markerColorAxis$ | async"
                        (ngModelChange)="setDataColorAxis($event)"
                        [disabled]="!hasMarkers"
                    >
                        <clr-options>
                            <clr-option
                                *clrOptionItems="let marker of availableColorMarkers; field: 'name'"
                                [clrValue]="marker"
                            >
                                {{ marker.name }}
                            </clr-option>
                        </clr-options>
                    </clr-combobox>
                </clr-combobox-container>
            </div>
            <cds-tree>
                <ng-template #recursiveSelectionTree let-nodes>
                    <ng-container *ngFor="let node of nodes">
                        <cds-tree-item
                            [expanded]="node.show"
                            [expandable]="hasChildren(node)"
                            (expandedChange)="toggleNode(node)"
                            [disabled]="!!markerColorAxis"
                        >
                            <ng-container *ngIf="!node.isTopLevel; else topLevelLabel">
                                <cds-checkbox>
                                    <label>{{ node.id }}</label>
                                    <input
                                        type="checkbox"
                                        [ngModel]="node.selected"
                                        (ngModelChange)="selectSelection(node)"
                                        [disabled]="!!markerColorAxis"
                                    />
                                </cds-checkbox>
                            </ng-container>
                            <ng-template #topLevelLabel>
                                <label>{{ node.id }}</label>
                            </ng-template>
                            <ng-container *ngIf="node.show && hasChildren(node)">
                                <ng-container
                                    *ngTemplateOutlet="
                                        recursiveSelectionTree;
                                        context: { $implicit: node.nodes }
                                    "
                                >
                                </ng-container>
                            </ng-container>
                        </cds-tree-item>
                    </ng-container>
                </ng-template>

                <ng-container
                    *ngTemplateOutlet="
                        recursiveSelectionTree;
                        context: { $implicit: selectionNodes }
                    "
                >
                </ng-container>
            </cds-tree>
        </ng-container>
    </ng-container>
</ng-container>
